module.exports = __webpack_public_path__ + "static/media/ankh.c7c66e8a.svg";